import React from 'react';
import {
  IRowMeta,
  RowType,
  setBuilderTimeWindowAction,
} from '../../../../../redux/slices/oldBuilder';
import {
  MAX_TIME_WINDOW,
  MIN_TIME_WINDOW,
} from '../../../../../config/constants';
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';
import * as BuilderUI from '../../../../../components/Builder/BuilderUI';
import BuilderNumberInputField from '../../../../../components/Builder/BuilderFields/BuilderNumberInputField';
import {
  DateKindKey,
  QueryType,
} from '../../../../../utils/apollo/graphqlSchema';
import { builderSelectedOptionsSelector } from '../../../../../redux/selectors/builder';
import { assertCondition } from '../../../../../utils/types';
import KubitTooltip from '../../../../../components/KubitTooltip';

const rowMeta: IRowMeta = {
  rowType: RowType.global,
  rowIndex: 0,
};

const FunnelTimeWindow = () => {
  const dispatch = useAppDispatch();

  const selectedOptions = useAppSelector((state) =>
    builderSelectedOptionsSelector(state),
  );

  assertCondition(selectedOptions?.type === QueryType.Funnel);

  const { dateKind } = selectedOptions;

  const timeWindow = useAppSelector(({ builder }) => builder.timeWindow);

  const handleChange = (newValue: number | null) => {
    dispatch(setBuilderTimeWindowAction({ newValue }));
  };

  const getTooltipContent = () => {
    if (dateKind === DateKindKey.Install) {
      return 'Rolling time window for every date cohort';
    } else if (dateKind === DateKindKey.Event) {
      return 'Extend the end date of the date range';
    }
  };

  return (
    <BuilderUI.BuilderFieldContainer>
      {/* connecting to the previous sentence, therefore lowercase*/}
      <BuilderUI.BuilderFieldLabel>
        date with an extended time window of
      </BuilderUI.BuilderFieldLabel>
      <KubitTooltip noOpenDelay={true} content={getTooltipContent()}>
        <BuilderNumberInputField
          placeholder="e.g. 5"
          value={timeWindow || null}
          onChange={handleChange}
          min={MIN_TIME_WINDOW}
          max={MAX_TIME_WINDOW}
          rowMeta={rowMeta}
          errorKey="timeWindow"
        />
      </KubitTooltip>
    </BuilderUI.BuilderFieldContainer>
  );
};

export default FunnelTimeWindow;
